import { DocumentResp } from '@services/documents/create';

export const parseFileErrors = (resp: DocumentResp) => {
  let errors = resp?.errors as { base: string };

  const keys = [
    'min_size_error',
    'max_size_error',
    'cannot_be_blank',
    'cannot_be_empty',
    'invalid',
  ];

  keys.forEach((key) => {
    if (errors?.base.includes(key)) errors = { ...errors, base: key };
  });

  return errors;
};
